import { createContext } from "react";

const FichasTecnicasContext = createContext();

export default FichasTecnicasContext;
